import { mainApi } from "services/main";
import {
  GetPaymentRequest,
  GetPaymentResponse,
  UpdatePaymentRequest,
  UpdatePaymentResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getPayment: builder.query<GetPaymentResponse, GetPaymentRequest>({
      query: (request: GetPaymentRequest) => ({
        url: `payment/${request.paymentId}/${request.gaiaObjectId}`,
      }),
    }),
    updatePayment: builder.mutation<
      UpdatePaymentResponse,
      UpdatePaymentRequest
    >({
      query: (request: UpdatePaymentRequest) => ({
        url: `payment/${request.paymentId}/${request.gaiaObjectId}`,
        body: request,
        method: "PUT",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useUpdatePaymentMutation,
  useGetPaymentQuery,
  useLazyGetPaymentQuery,
} = extendedApi;
